import {
  Component, Input, Output, ChangeDetectionStrategy, EventEmitter, forwardRef, OnInit, SimpleChanges, OnChanges,
  ChangeDetectorRef
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { commonService } from '../../service/common.service';
import { pgService } from '../../service/pg.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import {ActivatedRoute} from "@angular/router";
import {Globals } from '../../globals';
import {NgbCarouselConfig,NgbModalRef,NgbModal,ModalDismissReasons, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { userService } from '../../service/user.service';
import { } from '@types/googlemaps';
import { jobService } from '../../service/job.service';
import { contentService } from '../../service/content.service';
import { BarRatingModule } from "ngx-bar-rating";
import {NgbTabChangeEvent,NgbTabset,NgbTabsetConfig} from '@ng-bootstrap/ng-bootstrap';
import { Title,Meta } from "@angular/platform-browser";

@Component({
  selector: 'app-vjobdetail',
  templateUrl: './vjobdetail.component.html',
  styleUrls: ['./vjobdetail.component.css'],
  providers:[Title,Meta,NgbTabsetConfig,NgbTabset,Globals,pgService,NgbCarouselConfig,userService,jobService,contentService]
})
export class VjobdetailComponent implements OnInit {
  contexts = [];
  nextRate: number;
  disabled: boolean;

  /** Current rating. Can be a decimal value like 3.14 */

  @Input() rate=3;
  msg:any;
  isSuccess=false;
  isError=false;
  editId:any;
  jobdetails:any;
  filterdetail:any=[];
  public lat: string = '';
  public lng: string = '';
  
  salaryPeriodbox=[{'name':'HOUR','value':'per hour'},{'name':'DAY','value':'per day'},
  {'name':'WEEK','value':'per week'},{'name':'MONTH','value':'per month'},
  {'name':'YEAR','value':'per year'}
];
noofpositionbox=[{'name':'ONE','value':'1 hiring'},{'name':'TWO_FOUR','value':'2-4 hiring'},
{'name':'FIVE_TEN','value':'5-10 hiring'},{'name':'TEN_PLUS','value':'10+ hiring'},
{'name':'RECURRING_HIRE','value':'I have an ongoing need to fill this role'}
];
experienceYearsbox=[];
experiencereqbox=['Preferred','Required'];
educationreqbox=['Preferred','Required'];
minimumofeducationbox=[{'name':'12','value':'Secondary(10th Pass'},{'name':'14','value':'Higher Secondary(12th Pass)'},
{'name':'16','value':'Diploma'},{'name':'17','value':'Bachelor\'s'},
{'name':'20','value':'Master\'s'}
];


topicbox:any;
topiclist:any;
tagposttopic:any;
topic:any;
getimagesArry:any=[];
path=this.global.recruiterUrl;
userData:any;
modalReference:NgbModalRef;
msgpopup="";
Jobs='Jobs';


closeResult: string;
  userlist:any;
  isErrorExcel=false;
  isSuccessExcel=false;
  totalrow:number;
  totalrating:number=0;
  searchtxt:string;
  typetxt:string;
  notfound=false;
  pageSize = 10;
  currentPage = 0;
  start=0;
  end=10; 
  user:any;
  pageEvent: any;
  reviewform:any;
  msgclass:any="";
  activeTab:any;
  previousyear:any=[];
  showpreviousyear=false;
  jobtypearry=[{'key':'REGULAR','value':'Full time'},{'key':'PART_TIME','value':'Part Time'},{'key':'CONTRACT','value':'Contract'},{'key':'INTERN','value':'Intern'},{'key':'FREELANCE','value':'Freelance'}];
  reviewcontent=true;
  addreview=false;
  formvailidation=false;
  isclickbutton=false;


 
  constructor(private modalService: NgbModal,private _user:userService,config: NgbCarouselConfig,private router:Router,private route: ActivatedRoute,private commonservice:commonService,private global: Globals,private _pg:pgService,private job:jobService,private _content:contentService,private titleService: Title,private meta: Meta) { 
    this.jobdetails={
      'applyNow':'',
      'city':'',
      'company':'',
      'createdAt':'',
      'edureq':'',
      'exp':'',
      'expreq':'',
      'id':'',
      'isDeleted':'',
      'jobCategory':'',
      'jobEduSkillQua':'',
      'jobSummary':'',
      'jobTitle':'',
      'jobType':'',
      'jobbenefit':'',
      'latitude':'',
      'locationAddress':'',
      'longitude':'',
      'minofEdu':'',
      'recruiterdetail':'',
      'salary1':'',
      'salary2':'',
      'salaryPeriod':'',
      'state':'',
      'status':'',
      'updatedAt':'',
      'user':'',
      'userId':'',
      'workskill':'',
      'minofexp':''
    }
   this.reviewform={
     'Comment':'',
     'rating':'',
     'companyName':'',
     'emptype':'',
     'lastYear':'',
     'empStatus':'',
     'reviewTitle':'',
     'pros':'',
     'cons':'',
     'admgnt':''
   }
    this.commonservice.profile.subscribe((data:any)=>{
      
       if(data){
       this.userData=data; 
       }else{
         this.userData={};
       } 
  
     });
  }

  ngOnInit() {

  
    
    this.getposttopic();

    this.route.queryParams.subscribe(params => { 
      if(params['searchparam']){

        let searchArry:any;
              let resultpar={}
              searchArry=decodeURIComponent(atob(params['searchparam'])).split('&').forEach(function(part,index) {
                 var item = part.split('=');
                 resultpar[index] = item;
              });
             // console.log(resultpar);
              this.editId = resultpar[0][1];
              this.job.editjobdetails(this.editId).subscribe((data : any)=>{
                //console.log(data.results);
                //this.jobdetails=data.results;
                if(data.error==0){
                  let exparry;
                  var minedu='';
                  if(data.results.minofEdu!='' && data.results.minofEdu!=null){
                    exparry= this.minimumofeducationbox.find(x => x.name === data.results.minofEdu);
                   // console.log(exparry);
                    minedu=exparry.value;
                  }
                  if(data.results.recruiterimage!=null){
                    this.getimagesArry=data.results.recruiterimage.images.split(',');
                    
                   }
                   //console.log(this.path+this.getimagesArry[0]);
                
                this.jobdetails={
                  'applyNow':data.results.applyNow,
                  'city':data.results.city,
                  'company':data.results.company,
                  'createdAt':data.results.createdAt,
                  'edureq':data.results.edureq,
                  'educat':minedu,
                  'expreq':data.results.expreq,
                  'id':data.results.id,
                  'isDeleted':data.results.isDeleted,
                  'jobCategory':data.results.jobCategory,
                  'jobEduSkillQua':data.results.jobEduSkillQua,
                  'jobSummary':data.results.jobSummary,
                  'jobTitle':data.results.jobTitle,
                  'jobType':data.results.jobType,
                  'jobbenefit':data.results.jobbenefit,
                  'latitude':data.results.latitude,
                  'locationAddress':data.results.locationAddress,
                  'longitude':data.results.longitude,
                  'minofEdu':data.results.minofEdu,
                  'recruiterdetail':data.results.recruiterdetail,
                  'salary1':data.results.salary1,
                  'salary2':data.results.salary2,
                  'salaryPeriod':data.results.salaryPeriod,
                  'state':data.results.state,
                  'status':data.results.status,
                  'updatedAt':data.results.updatedAt,
                  'user':data.results.user,
                  'userId':data.results.userId,
                  'workskill':data.results.workskill,
                  'minofexp':(data.results.minofexp!='')?data.results.minofexp:'',
                  //'cityname':data.results.city.name,
                  'topic':data.results.topic,
                  'noofPosition':data.results.noofPosition,
                  'weburl':data.results.weburl
                }
                this.relatedjobs();
                this.getposttopic();
                this.getreviewerlist();
                this.setmetatitledes(data.results.jobTitle,data.results.jobSummary);
              }
                //console.log(this.jobdetails);
              });

      }
    });

    var previousYear = new Date();
    for(var k=0;k<=6;k++){
       this.previousyear.push(previousYear.getFullYear()-k);
    }

    
  }
  setmetatitledes(title,des){
    this.titleService.setTitle(title+' - MADEEASY');
    this.meta.addTag({ name: 'description', content: des });
  }

  getreviewerlist(){
    var ReviewType = 'JOB';
    this.job.getrecruiterReviewlistFront({0:this.start,1:this.end,2:this.searchtxt,3:this.jobdetails.userId,4:ReviewType}).subscribe((data : any)=>{

            if(data.error==0){ 
                this.userlist = data.results.rows;
                //console.log(this.userlist);
                this.totalrow = data.results.count;
                if(this.totalrow>0){
                  var rating=data.results.rows[0].totalrating;
                  var ratingcalper=rating/this.totalrow;
                  this.totalrating= Math.round(ratingcalper);
                }
                
                

              if(this.totalrow==0){
                this.notfound=true;
              }else{
                this.notfound=false;
              }
              
            }else{
              if(data.message=="Failed to authenticate token."){
                this.router.navigate(['/admin']);
              }else{
               this.msg = data.message;
               this.isError = true;
              }
            }
     },
       (error : HttpErrorResponse)=>{
         this.isError = true;
         this.msg="internal server error!";
       });
  
 }

 

  open(content) {
    if(Object.keys(this.userData).length == 0){
      this.needLogin();
      return false;
    } 

    this.msgpopup="";
    this.modalReference =  this.modalService.open(content,{ }); 
   /* this.modalReference= this.modalService.open(content,{size:"lg"}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });*/
}
  needLogin(){
    this.commonservice.setLoginBox(true);        
  }

  open2(content) { 
    this.modalService.open(content).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    });
  }

  public beforeChange($event: NgbTabChangeEvent) {
    if ($event.nextId === 'tab-preventchange2') {
      $event.preventDefault();
    }
  };

  onTabSelect(data: NgbTabChangeEvent) {
    if (data.hasOwnProperty('nextId')) { 
                //console.log('testtab');
            }   
    }


  topicfunc(data){
   return  data.split(',');
  }
  getTopicImage(imagename){
    return this.global.recruiterUrl+imagename;
    
  }

  registerrating(ratingform){
    let ratingDetails:any={};
    if(ratingform.status=="INVALID"){
      this.formvailidation=true;
      this.msgclass="danger";
      this.msgpopup="Please fill all required fields.";
    }
    else{
      this.formvailidation=false;
      //console.log(ratingform.value);
          if(this.userData){
            //console.log(this.userData);
            ratingDetails.rating=ratingform.value.Rating;
            ratingDetails.jobId=this.jobdetails.id;
            ratingDetails.comment=ratingform.value.comment;
            ratingDetails.userId=this.jobdetails.userId;
            ratingDetails.studentId=this.userData.id;
            ratingDetails.status='Inactive';
            ratingDetails.type='JOB';
            ratingDetails.empType=ratingform.value.EmpType;
            ratingDetails.lastYear=ratingform.value.LastYear;
            ratingDetails.empStatus=ratingform.value.EmpStatus;
            ratingDetails.reviewTitle=ratingform.value.ReviewTitle;
            ratingDetails.pros=ratingform.value.Pros;
            ratingDetails.cons=ratingform.value.Cons;
            // ratingDetails.admgnt=ratingform.value.Admgnt;
                this.job.addjobrating(ratingDetails).subscribe((data : any)=>{
                  if(data.error==0){ 
                    this.msgclass="success";
                    this.msgpopup="Review added successfully";
                    this.getreviewerlist();
                    this.reviewform={
                      'Comment':'',
                      'rating':'',
                    }
                  }
                });

          }

    }
    
  }
  
  getposttopic(){
    var category='Job';
    this._content.getposttopic(category).subscribe((data : any)=>{     
      if(data.error==0){     
        //this.getdownloadContent();
       var objArray = {};
       var mainArray = [];
       var newArray  = {}
       
       for(var row of data.results){
          objArray['display']= row.title;
          objArray['value']= row.id;
          newArray[row.id]=row.title;
            mainArray.push(objArray);
            objArray = {};
        }
       this.topicbox = mainArray;
      // console.log(this.topicbox);
      // console.log(newArray);
       this.topiclist = newArray;
       
       //this.topic=this.getpermissionArray(this.tagposttopic,this.topicbox);
 
      
    }else{
        if(data.message=="Failed to authenticate token."){
          sessionStorage.clear();
          localStorage.clear();
          this.router.navigate(['/']);
        }else{
         this.msg = data.message;
         this.isError = true;
        }
      }
    },
    (error : HttpErrorResponse)=>{
    this.isError = true;
    this.msg="internal server error!";
    });  
    

  }


  gettopic(topicId){
    var encodeURI =   encodeURIComponent(btoa(topicId));
   // console.log('>>>>>>'+encodeURI);
    //return false;
     this.router.navigateByUrl('/topic/'+encodeURI);
  }


  relatedjobs(){
    if(this.jobdetails.userId){
      this.job.editjobdetailsbyuserId(this.jobdetails.userId,this.jobdetails.id).subscribe((data : any)=>{
        if(data.error==0){
          //console.log(data.results);
          this.filterdetail=data.results.rows;
        }
      })
    }
  }

  relatedjoblist(id){
    let encodeUrl:any;

    if(id){
      encodeUrl="cid="+id+"&lat=77.2589646&lng=28.2222222";
       encodeUrl=encodeURIComponent(encodeUrl);
       //window.open(this.global.websiteUrl+'jobdetail?searchparam='+btoa(encodeUrl)); 
      this.router.navigateByUrl('/jobdetail?searchparam='+btoa(encodeUrl));
  
    }else{
      this.router.navigateByUrl('/job');
    }
   
  
  }

  onChangeemployee(event,value){
      
       if(value=='Former'){
        this.showpreviousyear=true;
       }else{
         this.showpreviousyear=false;
       }
  }
  reviewclick(val){
    
    if(val=='open'){
      this.addreview=true;
      this.reviewcontent=false;
    }else{
      this.addreview=false;
      this.reviewcontent=true;
    }
  }

  iaminterested(jobdetail){

    if(Object.keys(this.userData).length == 0){ 
      this.commonservice.setLoginBox(true); 
      return;

    }
    this.isclickbutton=true;
   var mainToipc = [];
    for(let topic of this.jobdetails.topic.split(',')){
       mainToipc.push(this.topiclist[topic]);
    }
    jobdetail.userData= {'firstName':this.userData.firstName,'lastName':this.userData.lastName,'email':this.userData.email};
    jobdetail.topic=mainToipc.join();
    this._content.iaminterested(jobdetail).subscribe((data : any)=>{     
      if(data.error==0){    
        this.isclickbutton=false; 
      alert('Job details sent successfully to your email.');
    }
    },
    (error : HttpErrorResponse)=>{
    this.isError = true;
    this.msg="internal server error!";
    }); 
  }

  jobtypebox(event){
    //console.log(event);
  }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/vjobdetail/vjobdetail.component.ts